import * as React from "react"
import { ChildrenProps } from "../../../@types/CapioWeb/core"
import { isBrowser } from '@capioweb/ui-components'
import { queryStaleTime } from '../../../constants'
import { getAllArticles } from '../../../api/getAllItems'
import { useQuery } from 'react-query'
import { AppContext } from '../../../context'

export interface ArticleFilterContextValue {
    activeArticleIds?: number[]
    updateActiveArticleIds: (key: number) => void
    data: any
    isLoading: boolean
    checkCategory?: (checked: boolean, heading: string) => void
}

export const ArticleFilterContext = React.createContext<ArticleFilterContextValue>({
    activeArticleIds: [],
    updateActiveArticleIds: (key: number) => null,
    data: null,
    isLoading: false,
    checkCategory: (checked: boolean, heading: string) => null
})

export const ArticleFilterContextProvider: React.FC<ChildrenProps> = (props) => {
    const { pageId } = React.useContext(AppContext)

    const [activeArticleIds, setActiveArticleIds] = React.useState([])

    const { data, isLoading } = useQuery(
        ["articles", pageId],
        () => isBrowser && pageId && getAllArticles(pageId),
        {
            staleTime: queryStaleTime,
        }
    )

    const updateActiveArticleIds = (key: number) =>
        setActiveArticleIds(
            activeArticleIds.includes(key)
                ? activeArticleIds.filter((activeKey) => activeKey !== key)
                : [...activeArticleIds, key]
        )

    const checkCategory = (checked: boolean, heading: string) => {
        if (data) {
            const filteredCategories = data?.filters.find((item) => item.key === heading).value.map((item2) => Number(item2.id))
            if (checked) {
                setActiveArticleIds([...activeArticleIds, ...filteredCategories])
            }
            else {
                if (activeArticleIds.length > 0) {
                    //Remove the categories from the activeArticleIds
                    setActiveArticleIds(activeArticleIds.filter((item) => !filteredCategories.includes(item)))
                }
            }
        }
    }

    return (
        <ArticleFilterContext.Provider
            value={{
                activeArticleIds,
                updateActiveArticleIds,
                data,
                isLoading,
                checkCategory
            }}
        >
            {props.children}
        </ArticleFilterContext.Provider>
    )
}
